<template>
  <div>
    <div class="row mb-4">
      <div class="col">
        <router-link to="/integrations" class="btn btn-secondary btn-no-r">
          Insigths
        </router-link>
        <router-link
          to="/integrations/ratings"
          class="btn btn-primary btn-no-r btn-no-l"
        >
          Ratings
        </router-link>
        <router-link
          to="/integrations/posts/feed"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Posts
        </router-link>
        <router-link
          to="/integrations/posts/tagged"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Tagged
        </router-link>
        <router-link to="/integrations" class="btn btn-no-l btn-secondary">
          Ads
        </router-link>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="nature-white-box">
          <div class="white-box-top"></div>
          <div class="row mt-3">
            <div class="col-md-4 col-lg-3">
              <div class="left-nav">
                <h2 class="semibold-16 mt-3 mb-1 ms-3">Pages</h2>
                <div class="items">
                  <button
                    v-for="page in pages.filter((e) => e.type == 3)"
                    :key="page.id"
                    class="btn w-100 text-start"
                    :class="
                      selectedPage?.id === page.id
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService(page.integration_service, page)"
                  >
                    <BaseIcon
                      :name="getLogo(page.integration_service)"
                      type="social"
                      class="logo-icon"
                    />
                    <span>{{ page.name }}</span>
                    <span class="badge ms-3" :class="getTypeClass(page.type)">{{
                      getTypeName(page.type)
                    }}</span>
                  </button>
                </div>
              </div>
              <h2 class="semibold-16 mt-3 mb-1 ms-3">Platforms</h2>
              <div class="left-nav">
                <div class="items">
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'Google' && selectedPage === null
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('Google')"
                  >
                    <BaseIcon
                      name="google-maps"
                      type="social"
                      class="logo-icon"
                    />
                    <span>Google</span>
                  </button>
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'Facebook'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('Facebook')"
                  >
                    <BaseIcon name="facebook" type="social" class="logo-icon" />
                    <span>Facebook</span>
                  </button>
                  <button
                    class="btn w-100 text-start"
                    :class="
                      selectedService === 'Trustpilot'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    "
                    v-on:click="selectService('Trustpilot')"
                  >
                    <BaseIcon
                      name="trustpilot"
                      type="social"
                      class="logo-icon"
                    />
                    <span>Trustpilot</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-lg-9">
              <div
                v-if="addNew && selectedService !== null"
                class="m-5 p-5 text-center"
              >
                <div class="bold-40">Connect an account</div>
                <p>Manage your data from Prodyflow</p>
                <template v-if="selectedService == 'TikTok'">
                  <button
                    class="btn btn-type-2 mt-4 me-2"
                    v-on:click="login('TikTokPersonal')"
                  >
                    <span>Connect Personal account</span>
                  </button>
                  <button
                    class="btn btn-type-2 mt-4"
                    v-on:click="login('TikTok')"
                  >
                    <span>Connect Ads account</span>
                  </button>
                </template>
                <template v-else>
                  <button class="btn btn-type-2 mt-4" v-on:click="login()">
                    <span>Connect account</span>
                  </button>
                </template>
              </div>
              <div v-else>
                <section>
                  <div class="row mb-5">
                    <div class="col-4">
                      <BaseIcon
                        name="star-filled"
                        v-for="i in Math.round(rating.total)"
                        :key="i"
                      />
                      <BaseIcon
                        name="star"
                        v-for="i in 5 - Math.round(rating.total)"
                        :key="i"
                      />
                    </div>
                    <div class="col-4 text-center">
                      <h2 class="bold-24 text-default mb-2">
                        {{ selectedPage?.rating_avg ?? rating.total }}
                      </h2>
                      <h2 class="bold-19 text-default">Total rating</h2>
                    </div>
                    <div class="col-4 text-center">
                      <h2 class="bold-24 text-black mb-2">
                        {{ selectedPage?.rating_count ?? rating.count }}
                      </h2>
                      <h2 class="bold-19 text-black">Rating count</h2>
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <div class="col-1">
                        <span class="regular-12 text-black mt-3">
                          Show in website
                        </span>
                      </div>
                    </div>
                    <div
                      v-for="review in filteredReviews"
                      :key="review.id"
                      class="row d-flex align-items-center mt-2"
                    >
                      <div class="col-auto">
                        <label class="cstm-check d-flex">
                          <input
                            type="checkbox"
                            v-model="review.show_in_website"
                            v-on:change="reviewShowInWebsite(review)"
                            :value="true"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div class="col-auto">
                        {{ formatDate(review.posted_at) }}
                      </div>
                      <div class="col-auto">
                        <BaseIcon
                          :name="getLogo(review.integration_service)"
                          type="social"
                          class="logo-icon"
                        />
                      </div>
                      <div class="col-2">
                        <template v-if="review.rate_max === 2">
                          <BaseIcon
                            :name="review.rate == 2 ? 'like' : 'dislike'"
                          />
                        </template>
                        <template v-else>
                          <BaseIcon
                            name="star-filled"
                            v-for="i in review.rate"
                            :key="i"
                          />
                          <BaseIcon
                            name="star"
                            v-for="i in review.rate_max - review.rate"
                            :key="i"
                          />
                        </template>
                      </div>
                      <div class="col">
                        {{ review.text }}
                      </div>
                      <div class="col-auto">
                        {{ review.username }}
                        <img
                          class="avatar-image"
                          :src="review.avatar"
                          v-if="review.avatar"
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import ws from "@/modules/ws";
import http from "@/modules/http";
import date from "@/modules/date";
import BaseIcon from "../../../components/icons/BaseIcon.vue";

export default {
  name: "Reviews",
  components: { BaseIcon },
  data() {
    return {
      store: useStore(),
      services: [],
      pages: [],
      data: [],
      reviews: [],
      posts: [],
      mentions: [],
      rating: {},
      activeMenu: "ratings",
      selectedService: null,
      selectedPage: null,
      addNew: false,
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    path() {
      return this.$route.path;
    },
    filteredReviews() {
      if (this.selectedPage === null) {
        return this.reviews;
      }
      return this.reviews.filter(
        (review) => review.integration_page_id === this.selectedPage.id
      );
    },
  },
  mounted() {
    this.loadData();

    ws.init();

    ws.subscribe("add", "contactMessage", (e) => {
      if (e.session !== this.sessionId) {
        this.messages.push(e.object);
        this.tableKey++;
      }
    });
  },
  methods: {
    getLogo(name) {
      switch (name) {
        case "google":
          return "google-maps";
        default:
          return name;
      }
    },
    getTypeClass(type) {
      switch (type) {
        case 1:
          return "primary";
        case 2:
          return "failed";
        case 3:
          return "light";
        default:
          return "";
      }
    },
    getTypeName(type) {
      switch (type) {
        case 1:
          return "Feed";
        case 2:
          return "Ads";
        case 3:
          return "Location";
        default:
          return "";
      }
    },
    formatDate(val) {
      return date.format(val, true, false);
    },
    login(service = null) {
      http
        .fetch(`/service-integrations/login/${service ?? this.selectedService}`)
        .then((data) => {
          location.href = data.redirect;
        });
    },
    saveProductToMedia(id, data) {
      http.fetch(`/service-integrations/tags/${id}/add-product`, {
        pos_x: data.pos_x,
        pos_y: data.pos_y,
        product_variant_id: data.product.variant_id,
      });
    },
    loadData() {
      let url = "/service-integrations/reviews";
      http.fetch(url).then((data) => {
        this.services = data.services;
        this.pages = data.pages;
        this.reviews = data.reviews;
        this.rating = data.rating;
      });
    },
    selectService(service, page = null) {
      if (service == "instagram") {
        service = "facebook";
      } else if (service == "tiktok") {
        service = "TikTok";
      }

      service = service.charAt(0).toUpperCase() + service.slice(1);

      this.selectedService = service;
      this.selectedPage = page;
      this.addNew = false;
      if (service === "TikTok") {
        if (this.services["TikTokPersonal"] || this.services["TikTok"]) {
          this.loadBasicData();
        } else {
          this.addNew = true;
        }
      } else if (this.services[service]) {
        this.loadBasicData();
      } else {
        this.addNew = true;
      }
    },
    loadBasicData() {
      http
        .fetch(`/service-integrations/basic/${this.selectedService}`)
        .then((data) => {
          this.data[this.selectedService] = data;
        });
    },
    reviewShowInWebsite(review) {
      http.fetch(`/service-integrations/reviews/${review.id}`, {
        show_in_website: review.show_in_website,
      });
    },
  },
};
</script>
